import { createTheme, type Theme } from '@mui/material/styles';

// Work Sans headings, scoped to exploration pages.
//
// llama sets h1/h2/h3 in Lora SemiBold Italic (h4 down are already Work Sans).
// This drops the serif for the sans across /explore/* only — every other
// prototype in Loft keeps Lora. It is a theme override rather than per-element
// font props on purpose: styling a heading at the call site is exactly the
// violation inspect mode flags, and it would have to be repeated on every
// Typography in the exploration.
//
// The family is read off the outer theme's body font rather than hard-coded,
// so this can't drift from whatever Work Sans stack llama is using.
//
// Applied to the whole subtree, frames included: the sketches are where the
// heading font actually gets judged, so leaving Lora inside the phones would
// make the comparison meaningless. Metrics (size, line-height, tracking,
// colour) are left as llama set them — only the family, style and weight move.
export const workSansHeadings = (outer: Theme): Theme => {
  const sans = {
    fontFamily: outer.typography.fontFamily,
    fontStyle: 'normal',
    fontWeight: outer.typography.fontWeightMedium,
  };

  return createTheme(outer, {
    typography: {
      h1: sans,
      h2: sans,
      h3: sans,
    },
  });
};
